const PHYSICAL_SETS = ['physical-sets-journal', 'physical-set-order', 'physical-set'];

export default PHYSICAL_SETS;
